module.exports = __webpack_public_path__ + "static/frontUserNew/img/door-advert-default.2d613074.png";